import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { ProjectScoreAnalysis } from "lib/resume-scoring/types";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const ProjectsCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: ProjectScoreAnalysis;
  maxScore: number;
  analysis: ResumeAnalysis["projects"];
  className?: string;
}) => {
  const criticalIssues = score.statementMistakeCount;
  const warningIssues = score.informationMistakeCount;
  const enhancements = score.linkMistakeCount;
  const isEmptyState = analysis.individualProjectsAnalysis.length === 0;

  return (
    <SectionCard
      title="Projects"
      icon="projects"
      score={score.totalScore}
      maxScore={maxScore}
      detailsLink="/score-check/projects"
      requiresPremium={true}
      emptyState={isEmptyState}
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        {criticalIssues !== 0 ? (
          <StatusItem
            icon="issue"
            title="Major Issues"
            subtitle="Impacting score"
            status="count"
            count={criticalIssues}
          />
        ) : (
          <StatusItem
            icon="noIssue"
            title="No issue found"
            subtitle="Good impact in score"
            status="success"
          />
        )}

        {warningIssues !== 0 ? (
          <StatusItem
            icon="dateIssue"
            title="Missing Info"
            subtitle="Required information missing"
            status="count"
            count={warningIssues}
          />
        ) : (
          <StatusItem
            icon="dateIssue"
            title="Information obtained"
            subtitle="No info is missing"
            status="success"
          />
        )}

        {enhancements ? (
          <StatusItem
            icon="linkMissing"
            title="Links Missing"
            subtitle="Suggested to add links"
            status="count"
            count={enhancements}
          />
        ) : (
          <StatusItem
            icon="linkMissing"
            title="Links found"
            subtitle="Experience links detected"
            status="success"
          />
        )}
      </ul>
    </SectionCard>
  );
};
